import { render, staticRenderFns } from "./RunSpecificMigrationModal.vue?vue&type=template&id=3b9bf110&scoped=true&"
import script from "./RunSpecificMigrationModal.vue?vue&type=script&lang=ts&"
export * from "./RunSpecificMigrationModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b9bf110",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/winfakt-authentication-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3b9bf110')) {
      api.createRecord('3b9bf110', component.options)
    } else {
      api.reload('3b9bf110', component.options)
    }
    module.hot.accept("./RunSpecificMigrationModal.vue?vue&type=template&id=3b9bf110&scoped=true&", function () {
      api.rerender('3b9bf110', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dossier/RunSpecificMigrationModal.vue"
export default component.exports